import { Button, Form, message } from 'antd';
import dayjs from 'dayjs';
import { useCreatePriceCategory } from 'features/events/use-cases/create-price-category';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { payFormatDate } from 'utils/payload-date-';

import { AddPriceCategoryForm } from './add-price-category-form';
import {
  AgeGenderItem,
  PriceCategoryFormField,
  PriceCategoryFormValues,
} from './types';

export const AddPriceCategoryModal = ({
  onClose,
  editId,
  data,
  getEventDetaildata,
}: {
  onClose: () => void;
  showAddPriceModal: boolean;
  editId: any;
  getEventDetaildata: any;
  refetch: () => void;
  data: any;
}) => {
  const { id } = useParams();
  const eventId = id;
  const formName = 'add-price-category-form';
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<PriceCategoryFormValues>();
  const { isLoading, mutate } = useCreatePriceCategory(editId?.Id);
  const [selectedSeats, setSelectedSeats] = useState<number[]>([]);
  const [isFamily, setIsFamily] = useState<boolean>(false);
  const [familyParticipants, setFamilyParticipants] = useState<AgeGenderItem[]>(
    [],
  );
  const layoutData = JSON.parse(localStorage.getItem('event_details') || '{}');
  const countStartSeat = layoutData?.startSeatNumber || 1;

  const countEndSeat = process.env.REACT_APP_SUFFIX_Ticket_IDS
    ? 35
    : layoutData?.endSeatNumber || 32;
  // const countEndSeat = layoutData?.endSeatNumber || 32;
  const layoutType = layoutData?.Category || 'Normal';

  const bookedSeat = data?.reduce((acc: number[], item: any) => {
    if (item?.SeatNumber) {
      try {
        const seatNumbers = JSON.parse(item?.SeatNumber);

        return acc.concat(seatNumbers);
      } catch (error) {
        console.error('Error parsing SeatNumber:', error);
      }
    }

    return acc;
  }, []);

  const canUpdateSeat = editId?.SeatNumber
    ? JSON.parse(editId?.SeatNumber)
    : [];

  const seatArray = Array.from(
    { length: countEndSeat - countStartSeat + 1 },
    (_, i) => countStartSeat + i,
  );

  // Filter out booked seats unless they are in canUpdateSeat
  const filteredSeatArray = seatArray?.filter(
    (seat) => !bookedSeat?.includes(seat) || canUpdateSeat?.includes(seat),
  );

  const handleClose = () => {
    const registrationType = form.getFieldValue(
      PriceCategoryFormField.RegistrationType,
    );

    onClose();
    setSelectedSeats([]);
    setIsFamily(false);
    setFamilyParticipants([]);
    form.resetFields(); // always reset first

    form.setFieldsValue({
      RegistrationType: registrationType, // restore only in edit mode
    });
  };
  const getInitialValues = {
    [PriceCategoryFormField.Id]: undefined,
    [PriceCategoryFormField.EventId]: undefined,
    [PriceCategoryFormField.Category]: undefined,
    [PriceCategoryFormField.CategoryAr]: undefined,
    [PriceCategoryFormField.Description]: undefined,
    [PriceCategoryFormField.DateFrom]: undefined,
    [PriceCategoryFormField.DateTo]: undefined,
    [PriceCategoryFormField.NoOfPersons]: undefined,
    [PriceCategoryFormField.RegistrationType]: undefined,
    [PriceCategoryFormField.GenderType]: undefined,
    [PriceCategoryFormField.StartNumber]: undefined,
    [PriceCategoryFormField.EndNumber]: undefined,
    [PriceCategoryFormField.Utilization]: undefined,
    [PriceCategoryFormField.AgeFrom]: undefined,
    [PriceCategoryFormField.AgeTo]: undefined,
    [PriceCategoryFormField.CategoryId]: undefined,
    [PriceCategoryFormField.IsRefundable]: false,
    [PriceCategoryFormField.Refund_desc]: undefined,
    [PriceCategoryFormField.Refund_price]: undefined,
    [PriceCategoryFormField.IsDelivarable]: false,
    [PriceCategoryFormField.Delivery_desc]: undefined,
    [PriceCategoryFormField.Delivery_price]: undefined,
    [PriceCategoryFormField.MinPI]: 1,
    [PriceCategoryFormField.MinPT]: undefined,
    [PriceCategoryFormField.MaxPI]: undefined,
    [PriceCategoryFormField.MaxPT]: undefined,
    [PriceCategoryFormField.PriceIn]: undefined,
    [PriceCategoryFormField.PriceTe]: undefined,
    [PriceCategoryFormField.PriceType]: undefined,
    [PriceCategoryFormField.Status]: true,
    [PriceCategoryFormField.IsWaiting]: false,
    [PriceCategoryFormField.TotalWaiting]: undefined,
    [PriceCategoryFormField.RegistEndDate]: undefined,
    [PriceCategoryFormField.RegistStartDate]: undefined,
    [PriceCategoryFormField.IsHiddenFromGroup]: false,
    [PriceCategoryFormField.ShowTicketLayout]: false,
  };

  const handleUpdate = (formData: PriceCategoryFormValues) => {
    if (
      layoutType === 'Layout' &&
      (!selectedSeats || selectedSeats.length === 0)
    ) {
      message.error('Please select at least one seat number.');

      return;
    }

    const regType = Number(formData.RegistrationType);
    const isTeamOrBoth = regType === 2 || regType === 3;

    const teamMinPart = parseInt(
      formData.MinP_t ||
        form.getFieldValue(PriceCategoryFormField.MinPT) ||
        '0',
      10,
    );
    const teamMaxPart = parseInt(
      formData.MaxP_t ||
        form.getFieldValue(PriceCategoryFormField.MaxPT) ||
        '0',
      10,
    );

    if (
      isTeamOrBoth &&
      teamMaxPart > 0 &&
      teamMinPart > 0 &&
      teamMaxPart < teamMinPart
    ) {
      message.error(
        'Maximum number should be greater than or equal to minimum value',
      );

      return;
    }

    const indMinPart = parseInt(
      formData.MinP_i ||
        form.getFieldValue(PriceCategoryFormField.MinPI) ||
        '0',
      10,
    );
    const indMaxPart = parseInt(
      formData.MaxP_i ||
        form.getFieldValue(PriceCategoryFormField.MaxPI) ||
        '0',
      10,
    );

    if (
      (regType === 1 || regType === 3) &&
      indMaxPart > 0 &&
      indMinPart > 0 &&
      indMaxPart < indMinPart
    ) {
      message.error(
        'Maximum number should be greater than or equal to minimum value',
      );

      return;
    }

    if (isTeamOrBoth && isFamily) {
      if (teamMaxPart > 0 && familyParticipants.length > teamMaxPart) {
        message.error(
          `Participant count cannot exceed Team Max Part (${teamMaxPart}).`,
        );

        return;
      }

      if (teamMinPart > 0 && familyParticipants.length < teamMinPart) {
        message.error(
          `Please add at least ${teamMinPart} participant(s) as required by Team Min Part.`,
        );

        return;
      }

      if (familyParticipants.length === 0) {
        message.error('Please add at least one participant.');

        return;
      }

      // Validate all participants
      for (let i = 0; i < familyParticipants.length; i++) {
        const p = familyParticipants[i];
        const participantLabel = p.text?.trim() || `Participant ${i + 1}`;

        if (!p.text || !p.text.trim()) {
          message.error(`Participant ${i + 1}: English label cannot be empty.`);

          return;
        }

        if (p.text.trim().length > 15) {
          message.error(
            `Participant ${i + 1}: English label cannot exceed 15 characters.`,
          );

          return;
        }

        if (!p.text_Ar || !p.text_Ar.trim()) {
          message.error(`Participant ${i + 1}: Arabic label cannot be empty.`);

          return;
        }

        if (p.text_Ar.trim().length > 15) {
          message.error(
            `Participant ${i + 1}: Arabic label cannot exceed 15 characters.`,
          );

          return;
        }

        if (!p.gender) {
          message.error(`${participantLabel}: Please select Gender.`);

          return;
        }

        if (p.gender === 1) {
          if (p.ageFrom === undefined || p.ageFrom === null) {
            message.error(`${participantLabel}: Please enter Age From.`);

            return;
          }
          if (Number(p.ageFrom) <= 0) {
            message.error(
              `${participantLabel}: Age From must be greater than 0.`,
            );

            return;
          }
          if (p.ageTo === undefined || p.ageTo === null) {
            message.error(`${participantLabel}: Please enter Age To.`);

            return;
          }
          if (Number(p.ageTo) <= 0) {
            message.error(
              `${participantLabel}: Age To must be greater than 0.`,
            );

            return;
          }
          if (Number(p.ageTo) < Number(p.ageFrom)) {
            message.error(
              `${participantLabel}: Age To must be greater than or equal to Age From.`,
            );

            return;
          }
        } else if (p.gender === 2) {
          if (p.wAgeFrom === undefined || p.wAgeFrom === null) {
            message.error(`${participantLabel}: Please enter Age From.`);

            return;
          }
          if (Number(p.wAgeFrom) <= 0) {
            message.error(
              `${participantLabel}: Age From must be greater than 0.`,
            );

            return;
          }
          if (p.wAgeTo === undefined || p.wAgeTo === null) {
            message.error(`${participantLabel}: Please enter Age To.`);

            return;
          }
          if (Number(p.wAgeTo) <= 0) {
            message.error(
              `${participantLabel}: Age To must be greater than 0.`,
            );

            return;
          }
          if (Number(p.wAgeTo) < Number(p.wAgeFrom)) {
            message.error(
              `${participantLabel}: Age To must be greater than or equal to Age From.`,
            );

            return;
          }
        } else if (p.gender === 3) {
          if (p.ageFrom === undefined || p.ageFrom === null) {
            message.error(`${participantLabel}: Please enter Male Age From.`);

            return;
          }
          if (Number(p.ageFrom) <= 0) {
            message.error(
              `${participantLabel}: Male Age From must be greater than 0.`,
            );

            return;
          }
          if (p.ageTo === undefined || p.ageTo === null) {
            message.error(`${participantLabel}: Please enter Male Age To.`);

            return;
          }
          if (Number(p.ageTo) <= 0) {
            message.error(
              `${participantLabel}: Male Age To must be greater than 0.`,
            );

            return;
          }
          if (Number(p.ageTo) < Number(p.ageFrom)) {
            message.error(
              `${participantLabel}: Male Age To must be greater than or equal to Male Age From.`,
            );

            return;
          }
          if (p.wAgeFrom === undefined || p.wAgeFrom === null) {
            message.error(`${participantLabel}: Please enter Female Age From.`);

            return;
          }
          if (Number(p.wAgeFrom) <= 0) {
            message.error(
              `${participantLabel}: Female Age From must be greater than 0.`,
            );

            return;
          }
          if (p.wAgeTo === undefined || p.wAgeTo === null) {
            message.error(`${participantLabel}: Please enter Female Age To.`);

            return;
          }
          if (Number(p.wAgeTo) <= 0) {
            message.error(
              `${participantLabel}: Female Age To must be greater than 0.`,
            );

            return;
          }
          if (Number(p.wAgeTo) < Number(p.wAgeFrom)) {
            message.error(
              `${participantLabel}: Female Age To must be greater than or equal to Female Age From.`,
            );

            return;
          }
        }
      }

      const mandatoryCount = familyParticipants.filter(
        (p) => p.isMandatory,
      ).length;
      const minPart =
        parseInt(formData[PriceCategoryFormField.MinPT] || '1', 10) || 1;
      if (mandatoryCount > minPart) {
        message.error(
          `You cannot mark more than ${minPart} participant(s) as mandatory (Min Part is ${minPart}).`,
        );

        return;
      }

      formData.ageGenderList = familyParticipants.map((p, index) => ({
        id:
          p.id !== undefined && p.id !== null && p.id !== 0
            ? Number(p.id)
            : null,
        text: p.text?.trim() || `Participant ${index + 1}`,
        text_Ar: p.text_Ar?.trim() || '',
        orderNo: index + 1,
        gender: Number(p.gender),
        ageFrom:
          p.gender === 2
            ? null
            : p.ageFrom !== null && p.ageFrom !== undefined
            ? Number(p.ageFrom)
            : null,
        ageTo:
          p.gender === 2
            ? null
            : p.ageTo !== null && p.ageTo !== undefined
            ? Number(p.ageTo)
            : null,
        wAgeFrom:
          p.gender === 1
            ? null
            : p.wAgeFrom !== null && p.wAgeFrom !== undefined
            ? Number(p.wAgeFrom)
            : null,
        wAgeTo:
          p.gender === 1
            ? null
            : p.wAgeTo !== null && p.wAgeTo !== undefined
            ? Number(p.wAgeTo)
            : null,
        isMandatory: Boolean(p.isMandatory),
      }));
      formData.isFamily = true;
      const isTeamFamily = regType === 2;
      const showCommonAgeAndGender = isTeamFamily
        ? teamMinPart > 0 && teamMaxPart > teamMinPart
        : true;

      if (!showCommonAgeAndGender) {
        formData[PriceCategoryFormField.AgeFrom] = null;
        formData[PriceCategoryFormField.AgeTo] = null;
        formData[PriceCategoryFormField.GenderType] = null;
      } else {
        if (
          formData[PriceCategoryFormField.AgeFrom] !== null &&
          formData[PriceCategoryFormField.AgeFrom] !== undefined &&
          Number(formData[PriceCategoryFormField.AgeFrom]) <= 0
        ) {
          message.error('Age From must be greater than 0.');

          return;
        }
        if (
          formData[PriceCategoryFormField.AgeTo] !== null &&
          formData[PriceCategoryFormField.AgeTo] !== undefined &&
          Number(formData[PriceCategoryFormField.AgeTo]) <= 0
        ) {
          message.error('Age To must be greater than 0.');

          return;
        }
        formData[PriceCategoryFormField.AgeFrom] =
          formData[PriceCategoryFormField.AgeFrom] != null
            ? Number(formData[PriceCategoryFormField.AgeFrom])
            : null;
        formData[PriceCategoryFormField.AgeTo] =
          formData[PriceCategoryFormField.AgeTo] != null
            ? Number(formData[PriceCategoryFormField.AgeTo])
            : null;
        formData[PriceCategoryFormField.GenderType] =
          formData[PriceCategoryFormField.GenderType] != null
            ? String(formData[PriceCategoryFormField.GenderType])
            : null;
      }
    } else {
      formData.ageGenderList = [];
      formData.isFamily = false;
      formData[PriceCategoryFormField.AgeFrom] =
        formData[PriceCategoryFormField.AgeFrom] != null
          ? Number(formData[PriceCategoryFormField.AgeFrom])
          : null;
      formData[PriceCategoryFormField.AgeTo] =
        formData[PriceCategoryFormField.AgeTo] != null
          ? Number(formData[PriceCategoryFormField.AgeTo])
          : null;
      formData[PriceCategoryFormField.GenderType] =
        formData[PriceCategoryFormField.GenderType] != null
          ? String(formData[PriceCategoryFormField.GenderType])
          : null;
    }

    formData[PriceCategoryFormField.Id] = editId?.Id;
    formData[PriceCategoryFormField.EventId] = eventId;
    formData[PriceCategoryFormField.Refund_price] =
      formData.Refundable_charge ?? 0;
    formData[PriceCategoryFormField.Refund_desc] =
      formData.Refundable_description ?? '';
    formData[PriceCategoryFormField.Delivery_price] =
      formData.Delivery_charge ?? 0;
    formData[PriceCategoryFormField.Delivery_desc] =
      formData.Delivery_description ?? '';
    if (editId) formData[PriceCategoryFormField.PriceType] = editId.Price_type;
    formData[PriceCategoryFormField.Status] = true;
    formData[PriceCategoryFormField.RegistStartDate] =
      formData.WaitingStartDate && payFormatDate(formData.WaitingStartDate);
    formData[PriceCategoryFormField.RegistEndDate] =
      formData.WaitingEndDate && payFormatDate(formData.WaitingEndDate);

    formData[PriceCategoryFormField.DateFrom] =
      formData.Date_from && payFormatDate(formData.Date_from);
    formData[PriceCategoryFormField.DateTo] =
      formData.Date_to && payFormatDate(formData.Date_to);
    // formData[PriceCategoryFormField.TotalWaiting] = +formData.WaitingParticipant;
    formData[PriceCategoryFormField.IsWaiting] = formData.IsWaiting
      ? formData.IsWaiting
      : false;
    formData[PriceCategoryFormField.IsHiddenFromGroup] =
      formData.IsHiddenFromGroup ? formData.IsHiddenFromGroup : false;
    formData[PriceCategoryFormField.ShowTicketLayout] =
      formData.ShowTicketLayout ? formData.ShowTicketLayout : false;
    formData[PriceCategoryFormField.SeatNumber] =
      selectedSeats.length > 0 ? JSON.stringify(selectedSeats) : '';
    mutate(formData, { onSuccess: handleSuccess });
  };

  const handleSuccess = () => {
    handleClose();
    // refetch()
  };
  const isNormalLayout = layoutType === 'Normal';
  const isEventTicketing = getEventDetaildata?.events_ticketing;
  useEffect(() => {
    const shouldForceRegistrationType =
      layoutType === 'Layout' || (isNormalLayout && isEventTicketing);

    if (editId) {
      form.setFieldsValue({
        ...editId,
        WaitingStartDate: editId?.WaitingStartDate
          ? dayjs(editId.WaitingStartDate)
          : null,
        WaitingEndDate: editId?.WaitingEndDate
          ? dayjs(editId.WaitingEndDate)
          : null,
        Date_from: editId?.Date_from ? dayjs(editId.Date_from) : null,
        Date_to: editId?.Date_to ? dayjs(editId.Date_to) : null,
        RegistrationType: shouldForceRegistrationType
          ? 1
          : editId?.RegistrationType ?? undefined,
      });

      const isFam = Boolean(editId?.isFamily ?? editId?.IsFamily);
      setIsFamily(isFam);

      const rawList = editId?.ageGenderList || editId?.AgeGenderList;
      let parsedList = rawList;
      if (typeof rawList === 'string') {
        try {
          parsedList = JSON.parse(rawList);
        } catch {
          parsedList = [];
        }
      }

      if (Array.isArray(parsedList) && parsedList.length > 0) {
        const formattedList: AgeGenderItem[] = parsedList.map(
          (item: any, idx: number) => ({
            id: item.id ?? item.Id ? Number(item.id ?? item.Id) : null,
            text: item.text || item.Text || `Participant ${idx + 1}`,
            text_Ar:
              item.text_Ar ||
              item.Text_Ar ||
              item.text_ar ||
              item.Text_ar ||
              '',
            orderNo: item.orderNo ?? item.OrderNo ?? idx + 1,
            gender:
              item.gender ?? item.Gender
                ? Number(item.gender ?? item.Gender)
                : undefined,
            ageFrom: item.ageFrom ?? item.AgeFrom ?? null,
            ageTo: item.ageTo ?? item.AgeTo ?? null,
            wAgeFrom: item.wAgeFrom ?? item.WAgeFrom ?? item.wageFrom ?? null,
            wAgeTo: item.wAgeTo ?? item.WAgeTo ?? item.wageTo ?? null,
            isMandatory: Boolean(item.isMandatory ?? item.IsMandatory ?? false),
          }),
        );
        setFamilyParticipants(formattedList);
      } else {
        setFamilyParticipants([]);
      }

      setSelectedSeats(editId?.SeatNumber ? JSON.parse(editId.SeatNumber) : []);
    } else {
      setIsFamily(false);
      setFamilyParticipants([]);
      if (shouldForceRegistrationType) {
        form.setFieldsValue({ RegistrationType: 1 });
      } else {
        // Clear value when Normal only
        form.setFieldsValue({ RegistrationType: undefined });
      }
    }
  }, [editId, layoutType, getEventDetaildata]);

  return (
    <>
      {
        <>
          <div className='popup'>
            <div className='modal_head'>
              <h4>{editId ? 'Edit Tickets' : 'Add Tickets'}</h4>
              <button onClick={handleClose} className='close-btn'>
                &times;
              </button>
            </div>
            <div className='modal_body' style={{ overflow: 'hidden' }}>
              <Form<PriceCategoryFormValues>
                id={formName}
                name={formName}
                form={form}
                layout='vertical'
                initialValues={getInitialValues}
                onFinish={handleUpdate}
                // requiredMark={'optional'}
                onFinishFailed={() => {
                  setValidateTrigger(['onChange']);
                }}
                validateTrigger={validateTrigger}
                disabled={isLoading}
              >
                <div className='frmscrll'>
                  <AddPriceCategoryForm
                    editId={editId}
                    form={form}
                    selectedSeats={selectedSeats}
                    setSelectedSeats={setSelectedSeats}
                    layoutType={layoutType}
                    filteredSeatArray={filteredSeatArray}
                    getEventDetaildata={getEventDetaildata}
                    isFamily={isFamily}
                    setIsFamily={setIsFamily}
                    familyParticipants={familyParticipants}
                    setFamilyParticipants={setFamilyParticipants}
                  />
                </div>

                <div className='form-button'>
                  <Button type='primary' htmlType='submit' className='btn'>
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </>
      }
    </>
  );
};
